<template>
  <section class="media">
    <h1>Média</h1>
    <button class="add el-button" @click="dialogVisible = true">Ajouter</button>

    <el-row :gutter="10">
      <el-col :span="6" v-for="asset in media" :key="asset.mediaId">
        <el-card>
          <button class="delete" @click="deleteMedia(asset.mediaId)">✕</button>
          <img class="image" :src="asset.url" alt="">
          <div>
            <small>{{ asset.filename.slice(0,35) }}</small>
            <div class="bottom clearfix">
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>


    <ul class="pagination" v-if="this.allMedia">
      <li v-if="this.page > 1">
        <router-link :to="{ name: 'editor-media', params: { spaceId: $route.params.spaceId, page: page - 1 } }">&lt;</router-link>
      </li>
      <li v-if="this.page > 1">
        <router-link :to="{ name: 'editor-media', params: { spaceId: $route.params.spaceId, page: page - 1 } }">{{ this.page - 1 }}</router-link>
      </li>
      <li>
        <router-link class="current" :to="{ name: 'editor-media', params: { spaceId: $route.params.spaceId, page: page } }">{{ this.page }}</router-link>
      </li>
      <li v-if="this.allMedia.length > this.page * this.itemsByPage">
        <router-link :to="{ name: 'editor-media', params: { spaceId: $route.params.spaceId, page: page + 1 } }">{{ this.page + 1 }}</router-link>
      </li>
      <li v-if="this.allMedia.length > this.page * this.itemsByPage">
        <router-link :to="{ name: 'editor-media', params: { spaceId: $route.params.spaceId, page: page + 1 } }">&gt;</router-link>
      </li>
    </ul>

    <el-dialog title="Uploader des media" :visible.sync="dialogVisible">
      <p>Sélectionner, puis uploader une ou plusieurs media</p>
      <span>
        <el-upload ref="upload"
          class="upload-demo"
          multiple
          :action="uploadUrl"
          :headers="headers"
          list-type="picture-card"
          :data="{ name: 'Media', description: ' ' }"
          :on-success="uploaded"
          :on-error="errorUpload"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">Sélectionner<br>un ficher</el-button>
        </el-upload>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">Fermer</el-button>
        <el-button type="primary" @click="submitUpload">Uploader</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import api from '@/services/api';
import auth from '@/services/auth';

export default {
  name: 'media',
  data() {
    return {
      allMedia: null,
      media: null,
      page: 1,
      itemsByPage: 12,

      uploadUrl: '',
      dialogVisible: false,
      headers: {},
    };
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.page = parseInt(this.$route.params.page || this.page, 10);
      this.allMedia = await api.getMedia(this.$route.params.spaceId);
      this.media = this.allMedia.slice((this.page - 1) * this.itemsByPage, this.page * this.itemsByPage);
      this.uploadUrl = api.getUploadMediaUrl(this.$route.params.spaceId);
      this.headers.Authorization = auth.getAuthorizationHeader();
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    errorUpload() {
      this.$message({
        type: 'info',
        message: 'Upload impossible, veuillez réussir plus tard.',
      });
    },
    uploaded(response) {
      if (response) {
        this.$notify.success({
          title: 'Upload réussi',
          message: 'Média uploadés avec succès',
        });
        this.$refs.upload.clearFiles();
        this.closeDialog();
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.fetchData();
    },
    async deleteMedia(mediaId) {
      try {
        await this.$confirm('Cette action va supprimer le fichier. Continuer ?', 'Warning', {
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
          type: 'warning',
        });

        await api.deleteMedia(this.$route.params.spaceId, mediaId);
        await this.fetchData();
        this.$message({
          type: 'success',
          message: 'Fichier supprimé',
        });
      } catch (error) {
        this.$message({
          type: 'info',
          message: 'Suppression annulée',
        });
      }
    },
  },
};
</script>

<style lang="sass">
.media
  .pagination
    position: absolute
    top: 50px
    right: 140px
    li
      display: inline-block
      a
        margin: 0.1rem
        padding: 0.4rem 0.8rem
        list-style-type: none
        font-size: 0.8rem
        background: white
        border-bottom: 2px solid #dadada
        &.current
          border-color: #ff5050
  .add
    position: absolute
    top: 60px
    right: 40px
    z-index: 2000
  .el-card
    position: relative
    margin: 5px 0
  .delete
    position: absolute
    top: 5px
    right: 5px
    padding: 0
    width: 30px
    line-height: 30px
    color: white
    border: 0
    border-radius: 50%
    cursor: pointer
    background: #001861
    transition: all ease-in-out 0.2s
    &:hover
      background: #ff3c48
  .image
    width: 100%
    height: 200px
    object-fit: contain
    background: #FAFAFA url('data:image/svg+xml, <svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" fill-opacity=".1" ><rect x="200" width="200" height="200" /><rect y="200" width="200" height="200" /></svg>')
    background-size: 10px 10px
  .el-dialog
    .el-upload-list--picture-card .el-upload-list__item-thumbnail
      width: 100%
      height: 100%
      object-fit: cover

</style>
